export const projects = [
  {
    title: "Personality Prediction from Interview Transcripts",
    subtitle: "Python, scikit-learn, hugging face, pandas, numpy ",
    description: 
      "Built and deployed a machine learning model to predict personality traits from text, outperforming more complex neural network baselines while remaining faster and more interpretable. Contributed to research that secured a 15k CHF Innosuisse grant for continued study at École Polytechnique Fédérale de Lausanne.",
    image: "./demo.png",
    link:"https://whomlab-demo.netlify.app",
  },
  {
    title: "Neptune",
    subtitle: "TypeScript, Vercel, Supabase", 
    description: "Led team of 7 analysts and designers to develop Neptune's GTM platform with Apollo API integreation for contact sourcing, custom auto-populating email templates, and automated email sending with Brevo API.",
    image: "./Neptune.png",
    link: "https://docs.google.com/presentation/d/1VqpmOvN0fFhenJK0C8mRA-F3qEFUlBq0n6u2Fp-AMno/edit?usp=sharing"
  },
  {
    title: "Zephyr",
    subtitle: "Python, Roboflow, Supervision, Ultralytics",
    description: "Created a full-court basketball homography using Roboflow computer vision models to track player movement and ball trajectory. Integrated with Zephyr's existing data pipeline to deliver real-time insights to top-25 NCAA basketball teams.",
    image: "./Zephyr.png",
    link: "https://www.figma.com/slides/bnkBfhhhMLsbXavXDzWLHd/Zephyr-x-Atlas-Digital--FINAL-?node-id=1-284&t=Q4ILJVmnvODhzuMt-0"
  },
  {
    title: "Puppod ML API",
    subtitle: "Python, Flask, scikit-learn, Pandas, Heroku, Supabase",
    description: "Developed and deployed a full-stack machine learning application using Flask, scikit-learn, and React.js to analyze 130k+ user game sessions, predict key user data features, and deliver real-time insights via a Heroku-hosted API.",
    image: "./Puppod-ML.png",
    link: "https://github.com/kaavlu/puppod-ml/"
  },
  {
    title: "Simbi Mobile App",
    subtitle: "React Native, TypeScript, Android Studio, Expo",
    description: "Constructed and styled over 16 app screens and components for non-profit Simbi (YC S16), modernizing app experience for 1k+ active users. Collaborated with EM to resolve merge conflicts and coordinate team springs.",
    image: "./Simbu-image.png",
    link: "https://simbi.com/"
  },
  {
    title: "Application and Recruitment Portal",
    subtitle: "React, TailwindCSS, Firebase, Firestore",
    description:
      "Full-stack web application built for Atlas Digital Consulting Club recruitment. Implemented frontend views and user role privlages in JavaScript and deployed platform to 400+ applicants.",
    image: "./AD-Portal-IMG.png",
    link: "https://www.portal.atlasdigital.org/",
  },
  // {
  //   title: "Saphran Inc Data Dashboard",
  //   subtitle: "JavaScript, HTML/CSS",
  //   description:
  //     "Architected responsive data visualization dashboard tailored for asset planning and long-term profit forcasting. Improved menu system filtering over 30,000+ lines of company data.",
  //   image: "./Saphran.png",
  //   link: "saphran.com",
  // },
  // {
  //   title: "Machine Learning Forum Post Classifier",
  //   subtitle: "C++",
  //   description:
  //     "Designed and trained naïve Bayes machine learning classifier that reads and processes student posts via CSV files, calculates log-probability score of each post, and predicts labels for each given Piazza post with 87% accuracy (n=3000).",
  //   image: "./Screenshot 2024-06-03 113349.png",
  //   link: "https://github.com/tdvalencia/p5-ml",
  // },
];
